import { CellContext } from '@tanstack/react-table';
import { FC } from 'react';

import { useTableFooterContext } from '../../components/table-footer/TableFooterContext';

export function createFooterCell<T>(Component: FC<any>, defaultValue: T) {
  return function WrappedFooterCell(props: CellContext<unknown, unknown>) {
    const { data } = useTableFooterContext();
    const value = props.column.accessorFn?.(data, 0) ?? defaultValue;
    return <Component {...props} value={value} />;
  };
}
